var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"goods-404"},[_vm._v("\n  商品不存在："+_vm._s(_vm.goodsId)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }